export default "../fonts/ab-suite.svg";